import Modal from "@common/Modal";
import { sendOtpToDeleteAccount,deleteAccountRequest } from "@src/store/slices/user";


interface DeleteAccountConfirmModalProps {
    show: boolean;
    handleClose: () => void;
    onConfirm: () => void;
}

export default function DeleteAccountConfirmModal({
    show,
    handleClose,
    onConfirm,
}: DeleteAccountConfirmModalProps) {

    return (
        <div className="model-outer upload-error-popup delete-account-popup">
            <Modal show={show} handleClose={handleClose}>

                {/* Header */}
                <div className="modal-header">
                    <h2>Are you sure you want to delete this account?</h2>
                </div>

                {/* Body */}
                <div className="modal-body">
                    <span className="subheading">
                        These benefits will be discontinued
                    </span>

                    <ul className="delete-benefits-list">
                        <li>
                            <i className="ic-clearclose"></i>
                            <span>100% Timely Incentive Payout</span>
                        </li>
                        <li>
                            <i className="ic-clearclose"></i>
                            <span>Extra Side Income</span>
                        </li>
                        <li>
                            <i className="ic-clearclose"></i>
                            <span>Dashboard to Track Your Business</span>
                        </li>
                    </ul>
                </div>

                {/* Footer */}
                <div className="modal-footer">
                    <button
                        className="btn-line btn-delete"
                        onClick={onConfirm}
                    >
                        Yes, Delete
                    </button>

                    <button
                        className="btn-primary"
                        onClick={handleClose}
                    >
                        No
                    </button>
                </div>

            </Modal>
        </div>
    );
}
